import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { applyRemakeImageToSlot } from '@/lib/api/amazon-listing'

interface ApplyInput {
  remakeId: string
  generationId: string
  productId: string
  channelId: string
  slot: number
}

export function useApplyRemakeImageToSlot() {
  const qc = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: async (input: ApplyInput) => {
      const { remakeId, generationId, productId, channelId, slot } = input
      return applyRemakeImageToSlot(remakeId, generationId, {
        product_id: productId,
        channel_id: channelId,
        slot,
      })
    },
    onSuccess: (_d, v) => {
      qc.invalidateQueries({ queryKey: ['product-channel-assets', v.productId] })
      toast.success(t('remakeApply.media.appliedToast', { count: 1 }))
    },
    onError: (err: unknown) => {
      toast.error(err instanceof Error ? err.message : 'apply_failed')
    },
  })
}
